import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import PageNotFound from "../modules/page-not-found";
import PrivateRouter from "./PrivateRouter";
import PublicRouter from "./PublicRouter";
import SignIn from "../modules/auth/sign-in/SignIn";
import Dashboard from "../modules/pages/dashboard/Dashboard";
import ResetPassword from "../modules/auth/reset-password/ResetPassword";
import ForgotPassword from "../modules/auth/forgot-password/ForgotPassword";
import VerifyOtp from "../modules/auth/verify-otp/VerifyOtp";
import Advertising from "../modules/pages/advertising/Advertising";
import ManageSubscription from "../modules/pages/manage-subscription/ManageSubscription";
import AddAdvertising from "../modules/pages/advertising/AddAdvertising";
import UserManagement from "../modules/pages/user-management/UserManagement";
import ManagePodcast from "../modules/pages/manage-podcast/ManagePodcast";
import ViewPodcast from "../modules/pages/manage-podcast/ViewPodcast";
import Branding from "../modules/pages/branding/Branding";
import EditBranding from "../modules/pages/branding/EditBranding";
import AddUser from "../modules/pages/user-management/AddUser";
import ViewUser from "../modules/pages/user-management/ViewUser";
import ViewProfileDetails from "../modules/pages/profile/ViewProfileDetails";
import CMS from "../modules/pages/profile/CMS";
import UserActivityList from "../modules/pages/user-management/UserActivityList";
import PrivacyPage from "../modules/pages/cmspages/PrivacyPage";
import TermsPage from "../modules/pages/cmspages/TermsPage";
import CmsMgmnt from "../modules/pages/cms-mgmnt/CmsMgmnt";
import ViewNotify from "../modules/pages/notification/ViewNotify";
import NotificationComp from "../modules/pages/notification/NotificationComp";
import NotificationList from "../modules/pages/notification/NotificationList";
import ResetPasswordModal from "../modules/pages/user-management/ResetPasswordFormModal";
import { urlConstant } from "../constants/urlConstant";

export default function MainRoute() {
  return (
    <>
      <Routes>
        <Route path="/" element={<PublicRouter />}>
          <Route path="/" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/privacy-policy" element={<PrivacyPage/>} />
          <Route path="/terms-condition" element={<TermsPage />} />
        </Route>
        <Route path="/" element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/user-management/add-user" element={<AddUser />} />
          <Route path="/user-management/edit-user/:id" element={<AddUser />} />
          <Route path="/user-management/view-user/:id" element={<ViewUser />} />
          <Route path="/manage-podcast" element={<ManagePodcast />} />
          <Route
            path="/manage-podcast/view-podcast/:id"
            element={<ViewPodcast />}
          />
          <Route path="/branding" element={<Branding />} />
          <Route path="/branding/edit-branding" element={<EditBranding />} />
          <Route path="/advertising" element={<Advertising />} />
          <Route
            path="/advertising/add-advertisement"
            element={<AddAdvertising />}
          />
          <Route
            path="/advertising/edit-advertisement/:id"
            element={<AddAdvertising />}
          />
          <Route path={"/user-activity"} element={<UserActivityList />} />
          <Route path="/my-subscription" element={<ManageSubscription />} />
          <Route path="view-profile" element={<ViewProfileDetails />} />
          <Route path="terms-and-conditions" element={<CMS />} />
          <Route path="privacy-and-policy" element={<CMS />} />
          <Route path="about-us" element={<CMS />} />

           <Route
            path={urlConstant?.notification}
            element={<NotificationList />}
          />
          <Route
            path={urlConstant?.addNotification}
            element={<NotificationComp />}
          />
          <Route
            path={urlConstant?.viewNotification}
            element={<ViewNotify />}
          />
           <Route path="/cms-mgmnt" element={<CmsMgmnt />} />
        </Route>
      </Routes>
    </>
  );
}
